import * as React from 'react';
import { faTimes } from '@fortawesome/pro-light-svg-icons/faTimes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import isEqual from 'react-fast-compare';
import ItemSaveContainer from '@/components/ItemSave/ItemSaveContainer';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

type Props = {
    currentImageIndex: number;
    galleryLength: number;
    galleryTitle: string;
    itemId: number;
    onClose: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
};
const LightboxHeader = ({ currentImageIndex, galleryLength, galleryTitle, itemId, onClose }: Props) => (
    <>
        {/* Header content */}
        <HeaderContainer>
            <ContentContainer>
                <Text h2>{galleryTitle}</Text>
                <CloseIcon icon={faTimes} onClick={onClose} role="button" />
            </ContentContainer>
        </HeaderContainer>
        {/* Relative pagination and favorite button container */}
        <PaginationOverlay>
            {/* Absolute container */}
            <OverlayContainer>
                <ImageIndexCounter>
                    <Text colorWhite primary>
                        {currentImageIndex + 1} of {galleryLength}
                    </Text>
                </ImageIndexCounter>
                <StyledItemSaveContainer className="heart" itemId={itemId} />
            </OverlayContainer>
        </PaginationOverlay>
    </>
);

export default React.memo<Props>(LightboxHeader, isEqual);

const HeaderContainer = styled.header`
    background-color: ${({ theme }) => theme.colors.grey500};
    padding: 10px 20px;
    z-index: 10;
    user-select: none;
`;

const ContentContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const CloseIcon = styled(FontAwesomeIcon)`
    font-size: 35px;
    :hover {
        cursor: pointer;
    }
`;

const ImageIndexCounter = styled.div`
    padding: 3px 12px;
    opacity: 0.85;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.grey100};
    display: flex;
    align-items: center;
    justify-content: center;
`;

const PaginationOverlay = styled.div`
    position: relative;
`;

const OverlayContainer = styled.div`
    position: absolute;
    right: 0;
    left: 0;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > * {
        z-index: 10;
    }
`;

const StyledItemSaveContainer = styled(ItemSaveContainer).attrs(() => ({
    iconClassName: 'iconClassName',
}))`
    .iconClassName {
        svg {
            width: 27px;
            height: 26px;
            padding-bottom: 1;
        }
    }
`;
